export default "__VITE_ASSET__D4tYiF_G__"